// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type UserDetailAnalyticsQueryVariables = PrivateSchemaTypes.Exact<{
  filter: PrivateSchemaTypes.AnalyticsFilter;
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
  chartTimeUnit: PrivateSchemaTypes.TimeUnitEnum;
}>;


export type UserDetailAnalyticsQuery = (
  { __typename?: 'Query' }
  & { user?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'UserModelPublic' }
    & Pick<PrivateSchemaTypes.UserModelPublic, 'id' | 'display_name' | 'deleted_at' | 'image_url' | 'email' | 'first_name' | 'last_name' | 'account_name' | 'last_activity_at'>
    & { manager?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModelPublicBase' }
      & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'display_name'>
    )>, analytics?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'AnalyticsModel' }
      & { resources: (
        { __typename?: 'AnalyticsResourcesModel' }
        & Pick<PrivateSchemaTypes.AnalyticsResourcesModel, 'totalViewsCount' | 'uniqueViewedTopicsCount' | 'userActivityOverviewCount'>
        & { topicViewsByHour?: PrivateSchemaTypes.Maybe<Array<(
          { __typename?: 'AnalyticsHitCountByHourModel' }
          & Pick<PrivateSchemaTypes.AnalyticsHitCountByHourModel, 'count' | 'hour'>
        )>>, topicViewsByDay: Array<(
          { __typename?: 'AnalyticsHitCountByTimeUnit' }
          & Pick<PrivateSchemaTypes.AnalyticsHitCountByTimeUnit, 'count' | 'day'>
        )> }
      ), people: (
        { __typename?: 'AnalyticsPeopleModel' }
        & Pick<PrivateSchemaTypes.AnalyticsPeopleModel, 'totalUserSessionCount'>
      ), events: (
        { __typename?: 'AnalyticsEventsModel' }
        & Pick<PrivateSchemaTypes.AnalyticsEventsModel, 'attendedCount' | 'userEventsOverviewCount'>
      ), pathways: (
        { __typename?: 'AnalyticsPathwaysModel' }
        & Pick<PrivateSchemaTypes.AnalyticsPathwaysModel, 'completedCount' | 'enrolmentsCount'>
      ), workbooks: (
        { __typename?: 'AnalyticsWorkbooksModel' }
        & Pick<PrivateSchemaTypes.AnalyticsWorkbooksModel, 'completedCount' | 'workbooksCount'>
      ), surveys: (
        { __typename?: 'AnalyticsSurveysModel' }
        & Pick<PrivateSchemaTypes.AnalyticsSurveysModel, 'completedCount'>
      ) }
    )> }
  )> }
);


export const UserDetailAnalyticsDocument = gql`
    query UserDetailAnalytics($filter: AnalyticsFilter!, $userId: PositiveInt!, $chartTimeUnit: TimeUnitEnum!) {
  user(id: $userId) {
    id
    display_name
    deleted_at
    image_url
    email
    first_name
    last_name
    account_name
    last_activity_at
    deleted_at
    manager {
      id
      email
      display_name
    }
    analytics(filter: $filter) {
      resources {
        topicViewsByHour {
          count
          hour
        }
        totalViewsCount
        uniqueViewedTopicsCount
        topicViewsByDay: topicViewsByTimeUnit(unit: $chartTimeUnit) {
          count
          day
        }
        userActivityOverviewCount(overviewFilter: {userId: $userId})
      }
      people {
        totalUserSessionCount
      }
      events {
        attendedCount
        userEventsOverviewCount
      }
      pathways {
        completedCount
        enrolmentsCount
      }
      workbooks {
        completedCount
        workbooksCount
      }
      surveys {
        completedCount
      }
    }
  }
}
    `;

/**
 * __useUserDetailAnalyticsQuery__
 *
 * To run a query within a React component, call `useUserDetailAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailAnalyticsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      userId: // value for 'userId'
 *      chartTimeUnit: // value for 'chartTimeUnit'
 *   },
 * });
 */
export function useUserDetailAnalyticsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserDetailAnalyticsQuery, UserDetailAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserDetailAnalyticsQuery, UserDetailAnalyticsQueryVariables>(UserDetailAnalyticsDocument, options);
      }
export function useUserDetailAnalyticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserDetailAnalyticsQuery, UserDetailAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserDetailAnalyticsQuery, UserDetailAnalyticsQueryVariables>(UserDetailAnalyticsDocument, options);
        }
export type UserDetailAnalyticsQueryHookResult = ReturnType<typeof useUserDetailAnalyticsQuery>;
export type UserDetailAnalyticsLazyQueryHookResult = ReturnType<typeof useUserDetailAnalyticsLazyQuery>;
export type UserDetailAnalyticsQueryResult = Apollo.QueryResult<UserDetailAnalyticsQuery, UserDetailAnalyticsQueryVariables>;